module.exports = __webpack_public_path__ + "static/media/notFound.bfe47b24.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/notFound.jpg
// module id = 256
// module chunks = 0